import React from 'react'
import { useDispatch } from 'react-redux'
import { Route } from 'react-router-dom'
import { setRouteParams } from 'data/ui/actions'
import mapSearchToParams from './utils/mapSearchToParams'

function useAnalyticsPageTracking({ location, match }) {
  React.useEffect(
    () => {
      if (!window.analytics) {
        return
      }
      let title = 'App'
      if (location.pathname.includes('/p/')) {
        title = 'Public pages'
      }
      if (location.pathname.includes('/auth/')) {
        title = 'Sign in'
      }
      window.analytics.page('App', {
        title,
        referrer: null,
        search: null,
        url: match.path,
        path: match.path,
      })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [location.pathname]
  )
}

function useSetRouteParams({ match, location }) {
  const dispatch = useDispatch()
  React.useEffect(
    function onLocationChange() {
      // Sync route params with Redux store
      dispatch(
        setRouteParams({
          params: {
            ...match.params,
            ...mapSearchToParams(location.search),
          },
          location,
        })
      )
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [location.pathname + location.search]
  )
}

function RouteSyncComponent({ match, location }) {
  useSetRouteParams({ match, location })
  useAnalyticsPageTracking({ match, location })
  return null
}

export default function RouteSync() {
  return (
    <Route
      path={[
        '/app/channels/:channelId/notes/:noteId/:options?',
        '/app/channels/:channelId/notes',
        '/app/channels/:channelId/empty',
        '/app/channels/:channelId/select',
        '/app/filters/:filterId/notes/:noteId/:options?',
        '/app/filters/:filterId/notes',
        '/app/filters/:filterId/empty',
        '/app/filters/:filterId/select',
        '/app/channels/:channelId',
        '/app/notes/:noteId/:options?',
        '/app/templates/:templateId?',
        '/app/settings',
        '/auth/login',
        '/auth/request-reset-password',
        '/auth/reset-password',
        '/p/channel/:token',
        '/p/note/:token',
        '*',
      ]}
      render={({ match, location }) => (
        <RouteSyncComponent match={match} location={location} />
      )}
    />
  )
}
